import React, { useState } from 'react'
import SafeIcon from '../../common/SafeIcon'
import * as FiIcons from 'react-icons/fi'

const { FiX, FiExternalLink } = FiIcons

const NuPitchBadge = () => {
  const [isVisible, setIsVisible] = useState(true)

  if (!isVisible) return null

  return (
    <div className="fixed bottom-4 right-4 z-50">
      <div className="bg-white rounded-lg shadow-lg border border-gray-200 p-4 w-40 h-40 relative">
        <button
          onClick={() => setIsVisible(false)}
          className="absolute top-2 right-2 p-1 hover:bg-gray-100 rounded-full transition-colors"
          aria-label="Close badge"
        >
          <SafeIcon icon={FiX} className="w-3 h-3 text-gray-400" />
        </button>
        
        <div className="flex flex-col items-center justify-center h-full pt-4">
          {/* NuPitch Logo */}
          <div className="w-16 h-16 mb-3 flex items-center justify-center">
            <img 
              src="https://ymwrzyarkxxnsqllnnfu.supabase.co/storage/v1/object/public/assets/nupitch_logo_ol-Centered_001.svg"
              alt="NuPitch Logo"
              className="w-full h-full object-contain"
            />
          </div>
          
          <p className="text-xs text-gray-600 mb-3 text-center leading-tight">
            This presentation was<br />created with NuPitch
          </p>
          
          <a
            href="https://usenupitch.com"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center space-x-1 text-xs text-blue-600 hover:text-blue-700 font-medium transition-colors"
          >
            <span>Create your own</span>
            <SafeIcon icon={FiExternalLink} className="w-3 h-3" />
          </a>
        </div>
      </div>
    </div>
  )
}

export default NuPitchBadge
